<ng-container *ngIf="container">
  <div class="d-flex flex-column">
    <ng-container *ngIf="container?.title?.type === 'text'">
      <h5 class="h5 m-0 mb-4">{{ container?.title.text }}</h5>
    </ng-container>
    <ng-container *ngIf="container?.filters?.type === 'filter-set'">
      <flo-filter-set [filterSet]="container?.filters"></flo-filter-set>
    </ng-container>
    <ng-container *ngIf="container?.filters?.type === 'filter-search-set'">
      <div class="mx-n3 mx-sm-n45">
        <flo-search-filters 
          [searchModel]="container?.filters.search" 
          [filters]="container?.filters.filters"
          [filterByAction]="true"
          [searchByAction]="true"
        ></flo-search-filters>
      </div>
    </ng-container>
    <ng-container *ngIf="container?.content?.type === 'grid:container'">
      <flo-grid-container
        [container]="container?.content"
        [selectedItem]="selectedItem"
        (nextPage)="handleNextPage($event)"
      ></flo-grid-container>
    </ng-container>
  </div>
</ng-container>